import React, { useState } from "react";
import './HeaderSmall.css';
import SectorNav from "../HomeNav/SectorsNav";


const HeaderSmall = ({ }) => {
  const [showSectors, setShowSectors] = useState(false);
  const [showSystems, setShowSystems] = useState(false);
  function handleClickOutside() {
    setShowSectors(false);
    setShowSystems(false);
  }
  return (
    <nav className="navbar navbar-expand-lg d-flex justify-content-end myheader"
      style={{ backgroundColor: "#5a2684"}}>
        { showSectors && <SectorNav handleClickOutside={handleClickOutside} /> }
        <div className="container p-0">
          {/* Brand Name */}
          <a href="/">
            <img class="small-header-logo" src="/static/media/new_geller_white.afc828d5.svg"></img>
          </a>

          {/* Navbar Items */}
          <div className="d-flex ms-auto justify-content-end w-100">
            <a className="nav-link text-white small" href="/our_products/1">Products</a>
            <a className="nav-link text-white small" href="#"
              onClick={() => setShowSectors(!showSectors)}>Solutions</a>
            <a className="nav-link text-white small" href="/support">Support</a>
            <a className="nav-link text-white small" href="/news">News</a>

            {/* Button */}
            <a className="btn btn-info text-white-50 small rounded-pill" href="/search">
              <span className="small">Search for SDS</span>
            </a>
          </div>
        </div>
    </nav>
  );
};

export default HeaderSmall;



// WEBPACK FOOTER //
// src/components/HeaderSmall/HeaderSmall.jsx